
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { PlaceHolder } from "../../../../../../Entryfile/imagepath";
import Api from "../../../../../../initialpage/hooks/Api";
import useAuth from "../../../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
import useGetData from "../../../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie";
import { imageApi } from "../../../../../../initialpage/hooks/HrApi";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const englishWordCheck = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*|']*$/;
const ViewPendingRequisition = () => {
  const { requ_id } = useParams();
  const user = JSON.parse(Cookies.get("user") || '{}');
  const logInStatus = parseInt(Cookies.get("Role"));
  const [denyBox, setDenyBox] = useState(false);
  const [deniedRemark, setDeniedRemark] = useState("");
  const [approveBox, setApproveBox] = useState(false);
  const [proId, setProId] = useState(null);
  const navigate = useNavigate();
  const navigate1 = useNavigate();
  const { CountData, requisitionApprovedAdmin } = useGetData();
  const { mutate } = CountData();

  const { data: viewPendingReq } = requisitionApprovedAdmin(requ_id);
  const [productArray, setProductArray] = useState([]);

  useEffect(() => {
    if (viewPendingReq) {
      setProductArray(viewPendingReq.productsInfo);
    }
  }, [viewPendingReq]);

  console.log(viewPendingReq);

  console.log(productArray);
  const handleDeniedRequest = () => {
    //console.log("hitting");
    //console.log({req_id: requ_id,denyRemakrs: deniedRemark,user_name: user?.name_english});
    swal({
      title: "Are you sure?",
      text: "Once deny, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.put("store/requisition/deny/admin", {
          req_id: parseInt(requ_id),
          denyRemarks: deniedRemark,
          user_name: user?.name_english,
        }).then((res) => {
          //console.log(res);
          if (!res.data.error) {
            setDeniedRemark("");
            mutate();
            navigate("/requisitions/pending");
          }
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };
  const handleApprovedRequest = () => {
    //console.log("hitting");
    swal({
      title: "Are you sure?",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (productArray.length > 0) {
          const array = productArray.map((product) => {
            if (product.PROQTY < product.APROQTY) {
              swal({
                title: `${product.PRONAME}`,
                text: ` Doesn't have required quantity to approve !`,
                icon: "error",
                button: "Ok",
              });
            } else {
              const obj = {
                qty: product.APROQTY,
                remarks: product.ADMINREMARKS,
                proreqid: product.PROREQID,
              };
              return obj;
            }
          });
          console.log(array);
          API.put("store/requisition/approve/admin", {
            req_id: parseInt(requ_id),
            approvedBy: user?.name_english,
            products: array,
          }).then((res) => {
            console.log("d", res);
            if (!res.data.error) {
              swal({
                title: "Thank You !",
                text: "Successfully Approved",
                icon: "success",
                button: "Ok",
              });
              mutate();
              PostStoreLog(2, "Store requisition Approve by the admin");
              navigate("/requisitions/pending");
            }
          });
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  const updateProduct = (id, value, name) => {
    return productArray.map((item) => {
      let myItem = item;
      setProId(id);

      if (item.PROID === parseInt(id)) {
        myItem[name] = value;
      }
    });
  };

  const [imageStore, setImageStore] = useState("");

  return (
    <>
      <Helmet>
        <title>View Pending Requisition -  STORE</title>
        <meta
          name="description"
          content="View Pending Requisition -  STORE"
        />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate1(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">View Pending Requisition</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div>
              {!viewPendingReq ? (
                <NotFoundPage />
              ) : (
                <div className="row gx-5">
                  <div className="col-12 col-md-8 col-lg-8">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor ">
                              <th colSpan="12">Product Requisition Details</th>
                            </tr>
                          </thead>

                          {viewPendingReq.reqInfo && (
                            <tbody>
                              <tr className="lh-lg">
                                <td colSpan="4">Time & Date</td>
                                <td colSpan="8">
                                  {viewPendingReq.reqInfo.REQUITIME} ,
                                  {moment(
                                    new Date(viewPendingReq.reqInfo.REQUIDATE)
                                  ).format(" DD-MM-YYYY")}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Employee Name</td>
                                <td colSpan="8">
                                  {viewPendingReq.reqInfo.NAME_ENGLISH}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Designation</td>
                                <td colSpan="8">
                                  {viewPendingReq.reqInfo.DESIGNATION}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Department</td>
                                <td colSpan="8">
                                  {viewPendingReq.reqInfo.DEPARTEMENT}
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor text-center">
                              <th colSpan="2">S/N </th>
                              <th colSpan="4">Products</th>
                              <th colSpan="2">New Request</th>
                              <th colSpan="2">Last Req. Date</th>
                              <th colSpan="2">Last Req. Qty</th>
                              <th colSpan="2">
                                Total Qty ({new Date().getFullYear()})
                              </th>
                            </tr>
                          </thead>
                          {viewPendingReq.productsInfo && (
                            <tbody>
                              {viewPendingReq.productsInfo.map(
                                (product, index) => (
                                  <tr className="lh-lg" key={index}>
                                    <th className="text-center" colSpan="2">
                                      {index + 1}
                                    </th>
                                    <td colSpan="4">
                                      {product.PROIMAGE &&
                                        product.PROIMAGE != "null" ? (
                                        <img
                                          data-toggle="modal"
                                          className="me-2"
                                          data-target="#showImage"
                                          width={40}
                                          height={40}
                                          src={`${imageApi}${product.PROIMAGE}`}
                                          onClick={() =>
                                            setImageStore(product.PROIMAGE)
                                          }
                                        />
                                      ) : (
                                        <img
                                          src={PlaceHolder}
                                          alt=""
                                          width={40}
                                          height={40}
                                          className="me-2"
                                        />
                                      )}
                                      {englishWordCheck.test(
                                        product.PRONAME.replace(/\s/g, "")
                                      ) ? (
                                        <span className="storeTableFont">
                                          {product.PRONAME}
                                        </span>
                                      ) : (
                                        <span className="storeBanglaFont">
                                          {product.PRONAME}
                                        </span>
                                      )}
                                    </td>
                                    <td className="text-center" colSpan="2">
                                      {product.PROREQUQTY}{" "}
                                    </td>
                                    <td colSpan="2">
                                      {product.LAST_DATE
                                        ? moment(
                                          new Date(product.LAST_DATE)
                                        ).format("DD-MM-YYYY")
                                        : "-"}
                                    </td>
                                    <td className="text-center" colSpan="2">
                                      {product.LAST_QTY}{" "}
                                    </td>
                                    <td className="text-center" colSpan="2">
                                      {product.TOTAL_QTY > 0
                                        ? product.TOTAL_QTY
                                        : 0}
                                    </td>
                                  </tr>
                                )
                              )}

                              <tr className="lh-lg">
                                <th colSpan="2"></th>
                                <td colSpan="4" className="fw-bold text-center">
                                  Total Required Quantities{" "}
                                </td>
                                <td colSpan="2" className="fw-bold text-center">
                                  {viewPendingReq.totalQty}{" "}
                                </td>
                                <td colSpan="6"> </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 col-lg-4">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr
                              style={{
                                textAlign: "center",
                              }}
                              className=" tableColor  mb-1"
                            >
                              <th colSpan="12">Stock Product Details</th>
                            </tr>
                            <tr
                              style={{
                                textAlign: "center",
                              }}
                              className="tableColor"
                            >
                              <th colSpan="4">S/N </th>
                              <th colSpan="4">Product</th>
                              <th colSpan="4">Quantity</th>
                            </tr>
                          </thead>
                          {viewPendingReq.stockInfo && (
                            <tbody>
                              {viewPendingReq.stockInfo.map(
                                (product, index) => (
                                  <tr className="lh-lg" key={index}>
                                    <th className="text-center" colSpan="4">
                                      {index + 1}
                                    </th>
                                    {englishWordCheck.test(
                                      product?.proname?.replace(/\s/g, "")
                                    ) ? (
                                      <td
                                        colSpan="4"
                                        className="storeTableFont"
                                      >
                                        {product?.proname}
                                      </td>
                                    ) : (
                                      <td
                                        colSpan="4"
                                        className="storeBanglaFont"
                                      >
                                        {product?.proname}
                                      </td>
                                    )}
                                    {/* <td colSpan="4" className="storeBanglaFont">
                                      {product.PRONAME}
                                    </td> */}
                                    <td className="text-center" colSpan="4">
                                      {product?.proqty}{" "}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>

                  {logInStatus === 5 ? (
                    <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                      <button
                        className="btn btn-color_store px-3 mt-4"
                        onClick={() => {
                          setApproveBox(true);
                          setDenyBox(false);
                        }}
                      >
                        <i class="fa-solid fa-circle-info"></i>
                        <span> See Details</span>
                      </button>
                      {/* <button
                        className="btn btn-danger px-3 mt-4 ms-3"
                        onClick={() => {
                          setDenyBox(true);
                          setApproveBox(false);
                        }}
                      >
                        <i className="fa fa-xmark" />
                        <span> Deny</span>
                      </button> */}
                    </div>
                  ) : (
                    ""
                  )}

                  {denyBox && (
                    <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                      <div className="d-flex justify-content-center align-items-center  flex-column">
                        <div className="mb-3 w-50">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            {" "}
                            Deny Remarks <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control input-field-new"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            onChange={(e) => {
                              setDeniedRemark(e.target.value);
                            }}
                          ></textarea>
                        </div>
                        <div>
                          <button
                            className="btn btn-color_store px-3 mt-4"
                            onClick={handleDeniedRequest}
                          >
                            <i className="fa fa-check" />
                            <span> Submit</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {approveBox && (
                    <div className="col-12 col-md-12 col-lg-12 text-center mt-5">
                      <div className="mt-3">
                        <div className="table-responsive-sm data-table">
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr className="tableColor text-center">
                                <th colSpan="1">S/N </th>
                                <th colSpan="2">Products</th>
                                <th colSpan="1">Required</th>
                                <th colSpan="1">Units</th>
                                <th colSpan="2">Approved</th>
                                <th colSpan="2">Comments </th>
                                <th colSpan="2">Remarks</th>
                              </tr>
                            </thead>
                            {/* productArray */}
                            <tbody>
                              {viewPendingReq.productsInfo &&
                                viewPendingReq.productsInfo.map(
                                  (product, index) => (
                                    <tr key={index}>
                                      <td colSpan="1" className="text-center">
                                        {++index}
                                      </td>
                                      <td colSpan="2">{product.PRONAME} </td>
                                      <td colSpan="1">{product.PROREQUQTY}</td>
                                      <td colSpan="1">{product.UNIT}</td>
                                      <td colSpan="2">
                                        {" "}
                                        <input
                                          type="number"
                                          style={{
                                            width: "100%",
                                            paddingLeft: "5px",
                                            height: "40px",
                                          }}
                                          onChange={(e) => {
                                            updateProduct(
                                              product.PROID,
                                              parseInt(e.target.value),
                                              "APROQTY"
                                            );
                                          }}
                                          className="input-field-new text-center"
                                          defaultValue={product.PROREQUQTY}
                                        />
                                      </td>
                                      <td colSpan="2">
                                        <textarea
                                          type="text"
                                          style={{
                                            width: "100%",
                                            height: "70px",
                                            paddingLeft: "5px",
                                          }}
                                          className="input-field-new"
                                          placeholder={product.PREMARKS}
                                          disabled
                                        />
                                      </td>
                                      <td colSpan="2">
                                        <textarea
                                          type="text"
                                          style={{
                                            width: "100%",
                                            height: "70px",
                                            paddingLeft: "5px",
                                          }}
                                          className="input-field-new"
                                          onChange={(e) => {
                                            updateProduct(
                                              product.PROID,
                                              e.target.value,
                                              "ADMINREMARKS"
                                            );
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-color_store px-3 mt-4"
                          onClick={handleApprovedRequest}
                        >
                          <i className="fa fa-check" />
                          <span> Approve</span>
                        </button>
                        <button
                          className="btn btn-danger px-3 mt-4 ms-3"
                          onClick={() => {
                            setDenyBox(true);
                            setApproveBox(false);
                          }}
                        >
                          <i className="fa fa-xmark" />
                          <span> Deny</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="modal bg-dark custom-modal fade"
          id="showImage"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content bg-dark">
              <div className="modal-header">
                <h5 className="modal-title text-light">Product Photo</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <img
                    className="img-fluid"
                    alt="Responsive image"
                    style={{
                      width: "350px",
                      height: "350px",
                    }}
                    src={`https://${imageApi}${imageStore}`}
                  />
                </div>
              </div>
              <div className="submit-section">
                <button
                  type="button"
                  className="btn btn-color_store text-white px-5 ms-1 py-2 mb-3 rounded"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPendingRequisition;
